// @flow

import styled, { css } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontBold, fontNormal } from "@fdr/static-ui/Typography";

export const WagerTypeContainer = styled.li`
  width: min-content;
  list-style: none;
  height: 66px;
`;

export const WagerType = styled.dt`
  color: ${buildColor("blue", "D1")};
  font-family: ${(props) => (!props.isActive ? fontNormal : fontBold)};
  font-size: 16px;
  height: 20px;
  text-align: left;
  white-space: nowrap;
`;

export const WagerDescription = styled.dd`
  color: ${buildColor("grey", "900")};
  font-size: 12px;
  height: 15px;
  text-align: left;
  white-space: nowrap;
`;

export const DescriptionWrapper = styled.dl`
  padding: 12px 0 14px;
  margin-right: 8px;
  margin-left: 8px;
  height: 62px;
  position: relative;
  ${({ isActive }) =>
    isActive &&
    css`
      &::after {
        content: "";
        background-color: ${buildColor("blue", "D1")};
        position: absolute;
        height: 2px;
        width: 100%;
        bottom: 0;
        left: 0;
      }
    `}
`;
